import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApi } from '@edl-development/edl-common';
import { ASSETS_URL } from '../tokens/api.token';

@Injectable()
export class ResourceApi extends BaseApi {

    constructor(
        @Inject(ASSETS_URL) private assetsUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getResourceFile(filePath: string) {
        return this.http.get(`${this.assetsUri}/${filePath}`, { responseType: 'text' });
    }


}
